import React, {FC, ReactNode, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {RestorationList} from './RestorationList';
import {RestorationAction} from './RestorationAction';
import {Container} from "@yosmanyga/rich-ui";
import {useService} from "@yosmanyga/di";
import {ProfileController} from "../../controller";
import {Basic} from "../Payment/Basic";

const Restoration = observer(
    ({
        templates,
        inverted,
        onRestore,
    }: {
        templates: {
            layout: FC<{
                basic?: boolean;
                list?: ReactNode;
                action?: ReactNode;
            }>;
        },
        inverted: boolean,
        onRestore: () => void,
    }) => {
        const profileController = useService(ProfileController, []);

        useEffect(() => {
            (async () => {
                await profileController.load();
            })();
        }, [profileController]);

        if (
            !profileController.loaded
        ) {
            return <templates.layout/>;
        }

        if (profileController.isBasic()) {
            return <Basic
                templates={{
                    layout: ({children}) => {
                        return <templates.layout
                            list={children}
                        />
                    }
                }}
                onGoToPayment={() => {
                    //
                }}
            />
        }

        return <templates.layout
            list={<Container
                height='100%'
            >
                <RestorationList
                    inverted={inverted}
                />
            </Container>}
            action={<RestorationAction onRestore={onRestore}/>}
        />
    }
);

export {Restoration};
